import config from "@/config"
import http from "@/utils/request"
// import tool from "@/utils/tool"
export default {
  orderOperation: {
    list: {
      url: `${config.API_URL}/orderOperate`,
      name: "获取商品",
      get: async function (params) {
        return await http.get(`${this.url}/manage/list`, params)
      },
      submit: async function (data) {
        return await http.post(`${this.url}/create`, data)
      },
      del: async function (data) {
        return await http.post(`${this.url}/delete`, data)
      },
      updataStatus: async function (data) {
        return await http.post(`${this.url}/updataStatus`, data)
      }
    }
  },
  storeReviewOperate: {
    list: {
      url: `${config.API_URL}`,
      name: "获取店铺审核记录",
      get: async function (data) {
        return await http.post(`${this.url}/application/manage/reviewOperate/list`, data)
      }
    }
  },
  demandOperate: {
    list: {
      url: `${config.API_URL}/demandOperate`,
      name: "获取需求审核记录",
      get: async function (data) {
        return await http.get(`${this.url}/manage/list`, data)
      }
    }
  },
  requirementOperate: {
    list: {
      url: `${config.API_URL}/requirementOperate`,
      name: "获取需求审核记录",
      get: async function (data) {
        return await http.get(`${this.url}/manage/list`, data)
      }
    }
  },
  audit: {
    url: `${config.API_URL}/auditLog`,
    name: "违规审核记录", //图片用户
    get: async function (data) {
      return await http.get(`${this.url}/manage/list`, data)
    }
  }
}
